<template>
  <div>
   <img v-if='!isAtlas'
        class="object-contain w-full h-full"
        :src='imageUrl'>
    <div v-else-if='spritesheetImage.style'
         class="object-contain w-full h-full"
         loading="lazy"
         :style='spritesheetImage.style' />

  </div>
</template>
<script>
import { toPairs } from 'lodash';
export default {
  props:{
    sprite:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      spritesheetData: {}
    }
  },
  async mounted() {
    if (!!this.sprite.atlas) {
      this.loadAtlas();
    }
  },
  methods:{
    async loadAtlas() {
      const url = this.api.makeSpritesheetUrlEditor(this.sprite.atlas);
      const response = await fetch(url);
      this.spritesheetData = await response.json();
      console.log('have spritesheetData', this.spritesheetData);
    }
  },
  inject:['api'],
  watch:{
    isAtlas(nv) {
      if (nv) {
        this.loadAtlas();
      }
    },
    'sprite.atlas'(nv) {
      if (nv) {
        this.loadAtlas();
      }

    }
  },
  computed:{
    imageUrl() {
      return this.api.makeImageUrlEditor(this.sprite.sprite);
    },
    isAtlas() {
      return !!this.sprite.atlas;
    },
    tilesheetImage() {
      if (this.spritesheetData.meta) {
        return this.api.makeSpritesheetUrlEditor(this.spritesheetData.meta.image);
      }
      return '';
    },
    tilesheetImages() {
      const url = this.tilesheetImage;
      if (url === '') {
        return [];
      }
      return toPairs(this.spritesheetData.frames)
        .map( ([name, tilespec]) => {
          const left = tilespec.frame.x;
          const top = tilespec.frame.y;
          //const left = 0;
          //const top = 0;
          const width = tilespec.frame.w;
          const height = tilespec.frame.h;
          //const width = 64;
          //const height = 64;

          //const scale = 64.0 / Math.max(width, height) 
          const scalex = 64.0 / width;
          const scaley = 64.0 / height;
          const scale = Math.min(scalex, scaley);
          //const dx = width - (width * scale)
          const dx = 0;
          const dy = 0;
          const style = {
            width: `${width}px`,
            height: `${height}px`,
            //background: `url(${url}) no-repeat`,
            //'background-position': `${left}px ${top}px`
            //'transform': `scale(${scale}) translate(${dx}px,${dy}px)`,
            'transform': `scale(${scale},${scale}) translate(${dx}px,${dy}px)`,
            'background': `url(${url}) ${-left}px ${-top}px`,
            'transform-origin':'top left'
          };

          const outerStyle = {
          }
          return {
            name,
            left,
            top,
            width,
            height,
            style,
            outerStyle
          }
        });
    },
    spritesheetImage() {
      const valids = this.tilesheetImages.filter( ({name}) => {
        return name === this.sprite.sprite;
      });
      if (valids.length) {
        return valids[0];
      } else {
        return {};
      }
    }
  },
}
</script>
